import { FormattedMessage, useIntl } from 'react-intl';

import { Icon, Tooltip } from '@ets/design-system';

import styles from './TableOfContentsElement.module.scss';

import { DISPLAY_TYPES, ELEMENTS } from 'Editor/services/consts';
import { BaseBlockElement } from '../../BaseViewBuilder';
import DOMElementFactory from 'Editor/services/DOMUtilities/DOMElementFactory/DOMElementFactory';
import { StylesUtils } from 'Editor/services/Edition_v2/Managers/Styles/StylesUtils';

import { Root } from 'react-dom/client';
import ReactUtils from '_common/utils/ReactUtils';

const TableOfContentsElementContent = () => {
  const intl = useIntl();

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'CONTENT_CANNOT_BE_EDITED' })}
      testId="table-of-contents-cannot-be-edited"
    >
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <Icon icon="list" size="4" testId="table-of-contents" />
        </div>
        <div className={styles.info}>
          <FormattedMessage id={'EDITOR_DOCUMENT_TABLE_OF_CONTENTS'} />
        </div>
      </div>
    </Tooltip>
  );
};

export class TableOfContentsElement extends BaseBlockElement {
  private container?: HTMLElement;
  private rootReactContainer?: Root;

  get selectableContent() {
    return this.container?.childNodes[0]?.childNodes[1] || null;
  }

  connectedCallback() {
    super.connectedCallback();
    // if (this.dataset.ver === '1') {
    //   this.buildElement();
    // }
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    ReactUtils.unmountReactComponent(this.rootReactContainer);
  }

  get ALLOWED_STYLE_ATTRIBUTES() {
    return StylesUtils.getAllowedBlockStyles('toc');
  }

  get displayType() {
    return DISPLAY_TYPES.BLOCK;
  }

  get isEditable() {
    return false;
  }

  get isDeletable() {
    return !this.isLocked;
  }

  get isSplitable() {
    return false;
  }

  get isSelectable() {
    return true;
  }

  buildElement() {
    this.innerHTML = '';

    // this.setAttribute('contentEditable', false);
    this.setAttribute('spellcheck', 'false');

    this.container = DOMElementFactory.buildElement('div');
    this.container.setAttribute('class', styles.container);

    this.appendChild(this.container);

    if (!this.rootReactContainer) {
      this.rootReactContainer = ReactUtils.createReactRoot(this.container);
    }
    ReactUtils.renderReactComponent(<TableOfContentsElementContent />, this.rootReactContainer);
  }
}

// register element
if (!window.customElements.get(ELEMENTS.TableOfContentsElement.IDENTIFIER)) {
  window.customElements.define(ELEMENTS.TableOfContentsElement.IDENTIFIER, TableOfContentsElement);
}
